import { Flair, User } from '../';
export class RoomMember {
  // Required
  user: User;
  flair?: Flair | null;

  constructor(user: User, flair?: Flair) {
    this.user = user;
    this.flair = flair;
  }
}
